import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import React from "react";

const Home = () => {
return (
    <div className="p-4 w-full mx-auto mt-16 bg-slate-200">
        <h1 className="text-4xl font-bold mb-6 text-center text-blue-700">
        Bienvenidos al Colegio La Inmaculada
        </h1>

    <div className="w-full">
        <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        emulateTouch
        dynamicHeight={false}
        >
        <div className="relative">
            <p className="legend">Actividades escolares</p>
            <img src="/imagenes/carrusel2.webp" alt="Foto 1" className=" w-full h-[530px]"/>
        </div>
        <div>
            <img src="/imagenes/carrusel3.webp" alt="Foto 2" className="object-cover w-full h-[530px]"/>
            <p className="legend">Eventos especiales</p>
        </div>
        <div>
            <img src="/imagenes/carrusel1.webp" alt="Foto 3" className=" w-full h-[530px]"/>
            <p className="legend">Instalaciones del colegio</p>
        </div>
        <div>
            <img src="/imagenes/carrusel4.webp" alt="Foto 4" className="object-cover w-full h-[530px]"/>
            <p className="legend">Actividades extracurriculares</p>
        </div>
        <div className="w-full h-[530px] overflow-hidden flex items-center justify-center">
            <img src="/imagenes/carrusel5.webp" alt="Foto 5" className="object-cover h-full w-full -translate-y-14 "/>
            <p className="legend">Logros deportivos</p>
        </div>
        </Carousel>
    </div>
    </div>
    );
};

export default Home;
